import React from 'react';
// import Chart from "chart.js";

class ChartComp extends React.Component{
    // chartRef = React.createRef();

    // componentDidMount(){

    //     let labels = [];
    //     let persentase = []
    //     this.props.indikator.map((indi) => {
    //         labels.push(indi.namaIndikator);
    //         persentase.push(parseFloat( ( indi.jumlahBenar / (indi.jumlahSoal * indi.jumlahSiswa) ) * 100).toFixed(2))
    //     })
        
    //     const myChartRef = this.chartRef.current.getContext("2d");
    //     new Chart(myChartRef, {
    //         type: "line",
    //         data: {
    //             //Bring in data
    //             labels: labels,
    //             datasets: [
    //                 {
    //                     label: "Persentase indikator",
    //                     data: persentase,
    //                 }
    //             ]
    //         },
    //         options: {
    //             scales: {
    //                 xAxes: [{
    //                     ticks: {
    //                         display: false //this will remove only the label
    //                     }
    //                 }],
    //                 yAxes: [{
    //                     display: true,
    //                     ticks: {
    //                         suggestedMin: 0,    // minimum will be 0, unless there is a lower value.
    //                         // OR //
    //                         beginAtZero: true,   // minimum value will be 0.
    //                         suggestedMax: 100
    //                     }
    //                 }]
    //             }
    //         }
    //     });
    // }

    render(){
        return(
            <div>
                {/* <canvas
                    id="myChart"
                    ref={this.chartRef}
                /> */}
            </div>
        )
    }
}

export default ChartComp;